import PropTypes from "prop-types";
import { FaImage, FaTimes, FaUser } from "react-icons/fa";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import InputField from "../../SharedComponent/Fields/InputField";
import TextareaField from "../../SharedComponent/Fields/TextareaField";
import Button from "../../SharedComponent/Button/Button";
import { API_END_POINTS } from "../../network/apiEndPoint";
import { postProtected } from "../../network/ApiService";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import HeroSection from "../HeroSection/HeroSection";

const initialCustomer = {
  // Company Information
  company_name: "",
  company_registration_number: "",
  vat_registration_number: "",
  managing_director: "",
  homepage: "",

  // Company Address
  street_address_1: "",
  street_address_2: "",
  zip_code: "",
  city: "",
  country: "",

  // Company Contact
  phone_number: "",
  email: "",
  invoiceEmail: "",

  // Contact Person
  contact_first_name: "",
  contact_last_name: "",
  contact_phone_number: "",
  contact_email: "",

  // Company Logo
  company_logo_url: null,

  // // Contact Image
  contact_image_url: null,
};

const CreateCustomerPage = ({ show, onSubmit }) => {
  const { t } = useTranslation();
  const [newCustomer, setNewCustomer] = useState({ ...initialCustomer });
  const navigate = useNavigate();
  const [loading , setLoading] = useState(false) ; 
  const [contactImage , setContactImage ] = useState("") ; 
  const [companyImage , setCompanyImage] = useState("")  ;

  function isValidURL(url) {
    const pattern = /^(https?:\/\/)[^\s/$.?#].[^\s]*$/i;
    return pattern.test(url.trim());
  }

  const onClose = () => {
    navigate("/dashboard");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewCustomer((prev) => ({ ...prev, [name]: value }));
  };

  const handleChangeFile = (e) => {
    const { name, value } = e.target;
    setNewCustomer((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    console.log("new customer = ", newCustomer);
  }, [newCustomer]);

  const handleCreateCustomer = async (e) => {
    
    e.preventDefault();
    console.log("homepage = " , newCustomer.homepage)
    if(!newCustomer.homepage == "" && !isValidURL(newCustomer.homepage))
    {
      toast.error(t("dashboardToasters.validUrl")); 
      return ;
    }
    if(isNaN ( Number(newCustomer.zip_code) )  ) 
      {
        toast.error(t("dashboardToasters.zipCodeInteger")) ; 
        return ; 
      }
      setLoading(true) ;
    try {
      const url = API_END_POINTS.customers;
      if (!url) throw new Error("API endpoint not defined");
      console.log("new customer = " , newCustomer) ; 
      const formData = new FormData();
      for (const key in newCustomer) {
        const value = newCustomer[key] ;
        
        if(key == "homepage") continue ;
        if(value == "" || !value ) continue ;
        formData.append(key, newCustomer[key]);
      }
  
      const response = await postProtected(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
  
      if (response) {
        setNewCustomer({ ...initialCustomer });
        toast.success(t("dashboardToasters.customerCreationSuccess") ) ;
        onClose(false);
      }
    } catch (error) {
      console.error("Create customer error:", error);
      const message = error?.response?.data?.messages?.[0]?.message;
      toast.error( t("dashboardToasters.genricError"));
    }
    finally{
      setLoading(false) ; 
    }
  };
  

  return (
    <div className="w-full bg-white px-4 sm:px-6 lg:px-8">
      <HeroSection t={t} showText = {false} />
      <div className="w-full max-w-9xl mx-auto py-6">
        <h2 className="text-2xl font-semibold mb-6">
          {t("customers.create.title")}
        </h2>

        <form onSubmit={handleCreateCustomer} className="space-y-6">
          {/* Company Information Section */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-lg font-medium mb-3 text-gray-800">
              {t("createCustomerDashboard.companyInformation")}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
              <InputField
                name="company_name"
                value={newCustomer.company_name}
                onChange={handleChange}
                maxLength={100}
                
                required
                explanation={t("createCustomerDashboard.companyName")}
                label={t("createCustomerDashboard.companyName")}
                placeholder={t("createCustomerDashboard.companyNamePlaceholder")}
              />

              <InputField
                name="company_registration_number"
                value={newCustomer.company_registration_number}
                onChange={handleChange}
               
                maxLength={100}
                 explanation={t("createCustomerDashboard.companyRegistrationNumber")}
                label={t("createCustomerDashboard.companyRegistrationNumber")}
                placeholder={t("createCustomerDashboard.companyRegistrationNumberPlaceholder")}
              />

              <InputField
                name="vat_registration_number"
                value={newCustomer.vat_registration_number}
                onChange={handleChange}
                maxLength={100}
                explanation={t("createCustomerDashboard.vatRegistrationNumber")}
                title={t("createCustomerDashboard.vatRegistrationNumber")}
                label={t("createCustomerDashboard.vatRegistrationNumber").slice(0,12)+ " ..."}
                placeholder={t("createCustomerDashboard.vatRegistrationNumberPlaceholder")}
              />

              <InputField
                name="managing_director"
                value={newCustomer.managing_director}
                onChange={handleChange}
                maxLength={100}
                explanation={t("createCustomerDashboard.managingDirector")}
                label={t("createCustomerDashboard.managingDirector")}
                placeholder={t("createCustomerDashboard.managingDirectorPlaceholder")}
              />

              <InputField
                type = "url"
                name="homepage"
                value={newCustomer.homepage}
                maxLength={100}
                onChange={handleChange}
                explanation={t("createCustomerDashboard.homepage")}
                label={t("createCustomerDashboard.homepage")}
                placeholder="https://www.company.com"
              />
            </div>
          </div>

          {/* Company Address Section */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-lg font-medium mb-3 text-gray-800">
              {t("createCustomerDashboard.companyAddress")}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
              <InputField
                name="street_address_1"
                value={newCustomer.street_address_1}
                maxLength={100}
                onChange={handleChange}
                required
                explanation={t("createCustomerDashboard.streetAddress1")}
                label={t("createCustomerDashboard.streetAddress1")}
                placeholder={t("createCustomerDashboard.streetAddressPlaceholder")}
              />

              <InputField
                name="street_address_2"
                value={newCustomer.street_address_2}
                maxLength={100}
                onChange={handleChange}
                explanation={t("createCustomerDashboard.streetAddress2")}
                label={t("createCustomerDashboard.streetAddress2")}
                placeholder={t("createCustomerDashboard.streetAddressPlaceholder2")}
              />

              <InputField
                name="zip_code"
                value={newCustomer.zip_code}
                maxLength={100}
                onChange={handleChange}
                required
                explanation={t("createCustomerDashboard.zipCode")}
                label={t("createCustomerDashboard.zipCode")}
                placeholder={t("createCustomerDashboard.zipCodePlaceholder")}
              />

              <InputField
                name="city"
                value={newCustomer.city}
                maxLength={100}
                onChange={handleChange}
                required
                explanation={t("createCustomerDashboard.city")}
                label={t("createCustomerDashboard.city")}
                placeholder={t("createCustomerDashboard.cityPlaceholder")}
              />

              <InputField
                name="country"
                value={newCustomer.country}
                onChange={handleChange}
                maxLength={100}
                required
                explanation={t("createCustomerDashboard.country")}
                label={t("createCustomerDashboard.country")}
                placeholder={t("createCustomerDashboard.countryPlaceholder")}
              />
            </div>
          </div>

          {/* Company Contact Section */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-lg font-medium mb-3 text-gray-800">
              {t("createCustomerDashboard.companyContactInformation")}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <InputField
                name="phone_number"
                value={newCustomer.phone_number}
                onChange={handleChange}
                maxLength={20}
                required
                 explanation={t("createCustomerDashboard.phone")}
                label={t("createCustomerDashboard.phone")}
                placeholder="+49 123 4567890"
              />

              <InputField
                name="email"
                value={newCustomer.email}
                maxLength={50}
                onChange={handleChange}
                type="email"
                required
                explanation={t("createCustomerDashboard.email")}
                label={t("createCustomerDashboard.email")}
                placeholder="contact@company.com"
              />

              <InputField
                name="invoiceEmail"
                value={newCustomer.invoiceEmail}
                onChange={handleChange}
                maxLength={50}
                type="email"
                explanation={t("createCustomerDashboard.invoiceEmail")}
                label={t("createCustomerDashboard.invoiceEmail")}
                placeholder="invoice@company.com"
              />
            </div>
          </div>

          {/* Contact Person Section */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-lg font-medium mb-3 text-gray-800">
              {t("createCustomerDashboard.contactPersonPlaceholder")}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <InputField
                name="contact_first_name"
                value={newCustomer.contact_first_name}
                onChange={handleChange}
                maxLength={50}
                explanation={t("createCustomerDashboard.firstName")}
                label={t("createCustomerDashboard.firstName")}
                placeholder={t("createCustomerDashboard.firstNamePlaceholder")}
              />

              <InputField
                name="contact_last_name"
                value={newCustomer.contact_last_name}
                onChange={handleChange}
                maxLength={50}
                explanation={t("createCustomerDashboard.lastName")}
                label={t("createCustomerDashboard.lastName")}
                placeholder={t("createCustomerDashboard.lastNamePlaceholder")}
              />

              <InputField
                name="contact_phone_number"
                value={newCustomer.contact_phone_number}
                onChange={handleChange}
                maxLength={20}
                 explanation={t("createCustomerDashboard.contactPhone")}
                label={t("createCustomerDashboard.contactPhone").slice(0,12) + " ..."}
                placeholder="+49 172 1234567"
              />

              <InputField
                name="contact_email"
                value={newCustomer.contact_email}
                onChange={handleChange}
                maxLength={50}
                type="email"
                 explanation={t("createCustomerDashboard.contactEmail")}
                label={t("createCustomerDashboard.contactEmail").slice(0,12) + " ..."}
                placeholder="contact.person@company.com"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Company Logo Section */}
           {companyImage && <div className="bg-gray-50 p-4 rounded-lg">
              <h3 className="text-lg font-medium mb-3 text-gray-800 flex items-center">
                <FaImage className="w-5 h-5 mr-2" />
                {t("createCustomerDashboard.companyLogo")}
              </h3>
              <div className="space-y-4">
                {/* Logo Preview */}
                {companyImage && (
                  <div className="mt-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {t("createCustomerDashboard.logoPreviewPlaceholder")}
                    </label>
                    <div
                      className="border border-gray-300 rounded-md p-4 bg-white flex items-center justify-center"
                      style={{ minHeight: "120px" }}
                    >
                      <img
                        src={companyImage}
                        alt="Company Logo"
                        className="max-h-20 max-w-full object-contain"
                        onError={(e) => {
                          e.target.style.display = "none";
                          e.target.nextSibling.style.display = "block";
                        }}
                      />
                      <div className="text-gray-500 text-sm hidden">
                        {t("createCustomerDashboard.logoNotAvailablePlaceholder")}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>}

            {/* Contact Image Section */}
           { contactImage && <div className="bg-gray-50 p-4 ">
              <h3 className="text-lg font-medium mb-3 text-gray-800 flex items-center">
                <FaUser className="w-5 h-5 mr-2" />
                {t("createCustomerDashboard.contactPersonImage")}
              </h3>
              <div className="space-y-4">
                {/* Contact Image Preview */}
                {contactImage && (
                  <div className="mt-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                     {t("createCustomerDashboard.contactImagePreview")}
                    </label>
                    <div
                      className="border border-gray-300 rounded-md p-4 bg-white flex items-center justify-center"
                      style={{ minHeight: "120px" }}
                    >
                      <img
                        src={contactImage}
                        alt="Contact Person"
                        className="max-h-20 max-w-full object-contain "
                        onError={(e) => {
                          e.target.style.display = "none";
                          e.target.nextSibling.style.display = "block";
                        }}
                      />
                      <div className="text-gray-500 text-sm hidden">
                        {t("createCustomerDashboard.contactImageNotAvailablePlaceholder")}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>}
          </div>


          {/* Company Logo & Contact Image Section */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Company Logo Section */}
            <div className="bg-gray-50 p-4 rounded-lg">
              <h3 className="text-lg font-medium mb-3 text-gray-800">
                {t("createCustomerDashboard.companyLogoPlaceholder")}
              </h3>
              <div className="space-y-4">
                <input
                  name="company_logo_url"
                  onChange={(e) =>
                  {
                    setNewCustomer({
                      ...newCustomer,
                      company_logo_url: e.target.files[0],
                    })
                    setCompanyImage(URL.createObjectURL(e.target.files[0])) ; 
                  }
                  }
                  type="file"
                  accept="image/*"
                />
              </div>
            </div>

            {/* Contact Image Section */}
            <div className="bg-gray-50 p-4 rounded-lg">
              <h3 className="text-lg font-medium mb-3 text-gray-800">
                {t("createCustomerDashboard.contactPersonImage")}
              </h3>
              <div className="space-y-4">
                <input
                  name="contact_image_url"
                  onChange={(e) =>
                  {
                    setNewCustomer({
                      ...newCustomer,
                      contact_image_url: e.target.files[0],
                    })
                    setContactImage(URL.createObjectURL(e.target.files[0]))
                  }
                  }
                  type="file"
                  accept="image/*"
                />
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-end gap-4 pt-4">
            <button
              type="button"
              onClick={onClose}
             
              className="w-full sm:w-auto px-6 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              {t("customers.create.buttons.cancel")}
            </button>

            <button
              type="submit"
              disabled={loading}
              className={`${loading ? "cursor-not-allowed" : "cursor-pointer"} w-full sm:w-auto px-6 py-2 bg-indigo-600 border border-transparent rounded-md shadow-sm text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}
            >
              {t("customers.create.buttons.create")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// CreateCustomerPage.propTypes = {
//   show: PropTypes.bool.isRequired,
//   onClose: PropTypes.func.isRequired,
//   onSubmit: PropTypes.func.isRequired,
// };

export default CreateCustomerPage;
